module.exports = __webpack_public_path__ + "img/SDG-16-EN-INVERTED.7be9e964.png";